export default __webpack_public_path__ + "static/more_info_smh-d9e95cd0a6ff7a0f3d023f5ed8c8ced2.pdf";